import { createAction } from '@reduxjs/toolkit'
import { Chapter, Rule, Section } from '../models/Rule'

export const setRuleList = createAction<any[]>('rule/setRuleList')
export const setCodeRules = createAction<any[]>('rule/setCodeRules')
export const setBookExtractPage = createAction<string>(
  'rule/setBookExtractPage',
)
export const setChapterList = createAction<Chapter[]>('rule/setChapterList')
export const updateSelectedChapter = createAction<Chapter | undefined>(
  'rule/updateSelectedChapter',
)
export const updateSelectedSection = createAction<Section | undefined>(
  'rule/updateSelectedSection',
)
export const setProjectName = createAction<string>('rule/setProjectName')
export const updateSelectedRule = createAction<Rule | undefined>(
  'rule/updateSelectedRule',
)
